import itMessages from 'ra-language-italian';

const it = {
    ...itMessages,
    resources: {
        events: {
            name: 'Evento |||| Eventi',
            fields: {
                title: 'Titolo',
                category: 'Categoria',
                country_id: 'Nazione',
                region_id: 'Regione',
                start_at: 'Inizio',
                end_at: 'Fine',
                online: 'Online',
                on_site: 'In loco',
                lat: 'Latitudine',
                lng: 'Longitudine',
                address: 'Indirizzo',
                organization_name: 'Nome organizzazione',
                organization_website: 'Sito web organizzazione',
                organization_contact_info: 'Informazioni di contatto dell\'organizzazione',
                intro: 'Introduzione',
                content: 'Contenuto',
                status: 'Stato',
                published: 'Pubblicato'
            }
        },
        account: {
            fields: {
                firstname: 'Nome',
                lastname: 'Cognome',
                password: 'Password',
                job_title: 'Titolo del lavoro',
                organization_name: 'Nome organizzazione',
                organization_address: 'Indirizzo dell\'organizzazione',
                organization_website: 'Sito web organizzazione',
                organization_contact_name: 'Nome del contatto dell\'organizzazione',
                organization_contact_email: 'Email del contatto dell\'organizzazione',
            }
        }
    },
    'Total': 'Totale',
    'My upcoming event(s)': 'I miei prossimi eventi',
    'Join us and create an event': 'Unisciti a noi e crea un evento',
    'Once your event is created the Europe Members team will review your event. If everything is in order, you will be prompted by e-mail and you will be able to publish your event.': 'Una volta creato l\'evento, il team di Europe Remembers lo esaminerà. Se tutto è in ordine, sarete avvisati via e-mail e potrete pubblicare il vostro evento.',
    'Create event': 'Crea evento',
    'Search': 'Cerca',
    'Country': 'Nazione',
    'Region': 'Regione',
    'Published': 'Pubblicato',
    'Online': 'Online',
    'On site': 'In loco',
    'Draft': 'Bozza',
    'Review': 'Revisione',
    'Accepted': 'Accettato',
    'Refused': 'Rifiutato',
    'Commemoration': 'Commemorazione',
    'Conference': 'Conferenza',
    'Festival': 'Festival',
    'Guided tour': 'Visita guidata',
    'Exhibition': 'Mostra',
    'Music-Theater': 'Musica-Teatro',
    'Other': 'Altro',
    'Ask for review': 'Richiedi una revisione',
    'Do you want to ask a review for the event': 'Vuoi richiedere una revisione per l\'evento?',
    'Unpublish': 'Rimuovi la pubblicazione',
    'Do you want to unpublish the event': 'Vuoi rimuovere la pubblicazione dell\'evento?',
    'Event published': 'Evento pubblicato',
    'Event unpublished': 'Evento rimosso dalla pubblicazione',
    'Publish': 'Pubblica',
    'Do you want to publish the event': 'Vuoi pubblicare l\'evento?',
    'Summary': 'Sommario',
    'Translations': 'Traduzioni',
    'Pictures': 'Immagini',
    'Title': 'Titolo',
    'Intro': 'Introduzione',
    'Content': 'Contenuto',
    'Picture': 'Immagine',
    'Description': 'Descrizione',
    'Copyright': 'Copyright',
    'Featured': 'In evidenza',
    'Account': 'Account',
    'Account updated': 'Account aggiornato',
    'Forgot password?': 'Password dimenticata?',
    'Forgot password': 'Password dimenticata',
    'An email has been sent': 'Una e-mail è stata inviata',
    'Email': 'E-mail',
    'Reset password': 'Reimposta la password',
    'Main picture': 'Immagine principale',
    'Default language': 'Lingua predefinita',
    'Event website': 'Sito web dell\'evento',
    'Europe Remembers : How to create an event ?': 'Europe Remembers: come creare un evento?',
    'Turn on subtitles (CC) to get instructions in your language.': 'Attivare i sottotitoli (CC) per ottenere le istruzioni nella propria lingua.',
    'Contribute to the project!': 'Contribuite \nal progetto!',
    'Europe Remembers aims to give visibility to your events and is free to use ! However we need your contributions to help us maintain and keep this platform running.': 'Europe Remembers mira a dare visibilità ai vostri eventi ed è gratuito! Tuttavia abbiamo bisogno dei vostri contributi per aiutarci a mantenere e far funzionare questa piattaforma.'
};

export default it;